import { Alert, Box } from '@mui/material';
import { isDemoMode } from 'utils/demoEnvironment';

export default function DemoEnvironmentBanner({ sx }) {
  if (!isDemoMode()) {
    return null;
  }

  return (
    <Box sx={{ width: '100%', ...sx }}>
      <Alert severity='info' icon={false} sx={{ borderRadius: 1, justifyContent: 'center' }}>
        Mobeat demo environment — shared sample subscription data (not your production app).
      </Alert>
    </Box>
  );
}
